import emptyInnerHTML from '@/common/helpers/empty-inner-html';
import cover from './cover';
import isBlank from './is-blank';
import isEmpty from './is-empty';

export default function (value, blankString = emptyInnerHTML) {
    return cover(value, isEmpty(value) || isBlank(value), blankString);
}
